/**
 * Last-known LiveKit participant count keyed to the Colyseus office room id.
 * Updated from LiveKitRoomConnector whenever connection status is dispatched.
 */

let lastColyseusRoomId: string | null = null
let lastNumParticipants = 0

/** Update snapshot (typically from LiveKitRoomConnector when Connected). */
export function setLivekitAnalyticsSnapshot(colyseusRoomId: string | null | undefined, numParticipants: number): void {
  lastColyseusRoomId = typeof colyseusRoomId === 'string' && colyseusRoomId.trim() !== '' ? colyseusRoomId : null
  lastNumParticipants = Number.isFinite(numParticipants) && numParticipants >= 0 ? numParticipants : 0
}

/** Read snapshot for correlation with room-local chat sends. */
export function getLivekitAnalyticsSnapshot(): { colyseusRoomId: string | null; numParticipants: number } {
  return { colyseusRoomId: lastColyseusRoomId, numParticipants: lastNumParticipants }
}
